let moment = require("moment");

$(document).ready(function () {
  let html = document.getElementsByTagName("HTML")[0];
  let body = document.querySelector(".mainBodyCRAT");
  body.classList.add("fadeIn");


  // Get everything needed to handle modal opening/closing
  let quickQuoteBtn = document.querySelectorAll(".quickQuoteBtn");
  let persQuoteBtn = document.querySelectorAll(".quoteBtnPersonal");
  let comQuoteBtn = document.querySelectorAll(".quoteBtnCommercial");
  let reservBtn = document.querySelectorAll(".reservationBtn");
  let quoteModal = document.getElementById("quoteModal");
  let modalClose = document.querySelectorAll(".quoteModalClose");
  let persModal = document.querySelector("#personalModal");
  let commModal = document.querySelector("#commercialModal");
  let resModal = document.querySelector("#reservationModal");

  // Get submit buttons
  let persSubmit = document.querySelector("#personalFormSubmit");
  let comSubmit = document.querySelector("#comFormSubmit");
  let resSubmit = document.querySelector("#resFormSubmit");

  //MAILCHIMP SIGN UP

  $("#mc-subscribe").submit(function () {
    if ($("input[name='radio-639[]']:checked")) {
      var formData = {
        firstName: $("input#mc-firstName").val(),
        lastName: $("input#mc-lastName").val(),
        email: $("input#mc-email").val(),
      };
      $.ajax({
        type: "POST",
        url: "/wp-content/themes/city-rent-a-truck/mailchimp-api-php.php",
        data: formData,
      })
        .done(function (data) {
          if (data["id"]) {
            $("#mc-message").html(
              "Thank you for signing up! You will receive an email shortly to confirm your subscription."
            );
          } else if (data["title"] == "Member Exists") {
            $("#mc-message").html(
              "Looks like you're already a member. Thanks for signing up!"
            );
          } else {
            $("#mc-message").html(
              "There was a problem with your submission. Please try again later or contact us if the issue persists."
            );
          }
        })
        .fail(function (req, error) {
          if (error === "error") {
            error = req.statusText;
          }
          console.log(error);
          $("#mc-message").html(
            "ERROR: There was a problem with your submission. Please try again later or contact us if the issue persists."
          );
        });

      return false;
    }
  });

  /* Create arrays of objects for each vehicle category to help make looping through them easier and for creating select options
    when vehicle category is picked on forms */
/* eslint-disable */

           let boxTruck = []
           for (var b = 0; b < script_vars.boxTrucks.length; b++) {
              boxTruck.push(script_vars.boxTrucks[b]);
            }

            let cargoVan = []
            for (var c = 0; c < script_vars.cargoVans.length; c++) {
              cargoVan.push(script_vars.cargoVans[c]);
            }

            let passengerVan = []
            for (var pv = 0; pv < script_vars.passengerVans.length; pv++) {
              passengerVan.push(script_vars.passengerVans[pv]);
            }

            let pickupTruck = []
            for (var pt = 0; pt < script_vars.pickupTrucks.length; pt++) {
              pickupTruck.push(script_vars.pickupTrucks[pt]);
            }

            let flatBedTruck = []
            for (var f = 0; f < script_vars.flatBedTrucks.length; f++) {
              flatBedTruck.push(script_vars.flatBedTrucks[f]);
            }

            let trailers = []
            for (var t = 0; t < script_vars.trailerss.length; t++) {
              trailers.push(script_vars.trailerss[t]);
            }
          

  // let boxTruck = [
  //   {
  //     name: "24ft Box w/ Lift",
  //     daily: {
  //       rate: 98,
  //       mileage: 0.27,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 585,
  //       mileage: 0.27,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 1675,
  //       mileage: 0.2,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "26ft Box w/ Lift",
  //     daily: {
  //       rate: 98,
  //       mileage: 0.27,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 585,
  //       mileage: 0.27,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 1675,
  //       mileage: 0.2,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "15ft Box w/ Lift Gate",
  //     daily: {
  //       rate: 62,
  //       mileage: 0.27,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 375,
  //       mileage: 0.27,
  //       freeMiles: 250,
  //     },
  //     monthly: {
  //       rate: 1250,
  //       mileage: 0.2,
  //       freeMiles: 1000,
  //     },
  //   },
  //   {
  //     name: "15ft Box w/ Ramp",
  //     daily: {
  //       rate: 62,
  //       mileage: 0.27,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 375,
  //       mileage: 0.27,
  //       freeMiles: 250,
  //     },
  //     monthly: {
  //       rate: 1250,
  //       mileage: 0.2,
  //       freeMiles: 1000,
  //     },
  //   },
  // ];

  // let cargoVan = [
  //   {
  //     name: "Cargo High Roof Transit",
  //     daily: {
  //       rate: 80,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 465,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1335,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "Cargo Medium Roof Transit",
  //     daily: {
  //       rate: 74,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 440,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1250,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "Extended Cargo Van",
  //     daily: {
  //       rate: 70,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 400,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1250,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "Cargo Van",
  //     daily: {
  //       rate: 65,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 385,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1200,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "Transit Connect",
  //     daily: {
  //       rate: 65,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 385,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1200,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  // ];



  // let passengerVan = [
  //   {
  //     name: "8 Passenger Transit",
  //     daily: {
  //       rate: 89,
  //       mileage: 0.22,
  //       freeMiles: 200,
  //     },
  //     weekly: {
  //       rate: 540,
  //       mileage: 0.22,
  //       freeMiles: 1500,
  //     },
  //     monthly: {
  //       rate: 1250,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "12 Passenger Transit",
  //     daily: {
  //       rate: 110,
  //       mileage: 0.22,
  //       freeMiles: 200,
  //     },
  //     weekly: {
  //       rate: 650,
  //       mileage: 0.22,
  //       freeMiles: 1500,
  //     },
  //     monthly: {
  //       rate: 1500,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "15 Passenger Transit",
  //     daily: {
  //       rate: 125,
  //       mileage: 0.22,
  //       freeMiles: 200,
  //     },
  //     weekly: {
  //       rate: 750,
  //       mileage: 0.22,
  //       freeMiles: 1500,
  //     },
  //     monthly: {
  //       rate: 1650,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "15 Passenger High Roof Transit",
  //     daily: {
  //       rate: 159,
  //       mileage: 0.22,
  //       freeMiles: 200,
  //     },
  //     weekly: {
  //       rate: 925,
  //       mileage: 0.22,
  //       freeMiles: 1500,
  //     },
  //     monthly: {
  //       rate: 1900,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "7 Passenger Luxury Van",
  //     daily: {
  //       rate: 165,
  //       mileage: 0.22,
  //       freeMiles: 200,
  //     },
  //     weekly: {
  //       rate: 985,
  //       mileage: 0.22,
  //       freeMiles: 1500,
  //     },
  //     monthly: {
  //       rate: 2250,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "Ford Expedition",
  //     daily: {
  //       rate: 95,
  //       mileage: 0.22,
  //       freeMiles: 200,
  //     },
  //     weekly: {
  //       rate: 575,
  //       mileage: 0.22,
  //       freeMiles: 1500,
  //     },
  //     monthly: {
  //       rate: 1350,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  // ];

  // let pickupTruck = [
  //   {
  //     name: "1 Ton Crew Cab 4x4",
  //     daily: {
  //       rate: 95,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 575,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1650,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "3/4 Ton Crew Cab 4x4",
  //     daily: {
  //       rate: 79,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 490,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1450,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "1/2 Ton Crew Cab 4x4",
  //     daily: {
  //       rate: 67,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 410,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1400,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "3/4 Ton Extended Cab 4x4",
  //     daily: {
  //       rate: 76,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 460,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1400,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "3/4 Ton Extended Cab w/ Liftgate",
  //     daily: {
  //       rate: 89,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 500,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1520,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "3/4 Ton Extended Cab Service Truck",
  //     daily: {
  //       rate: 89,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 500,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1520,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  //   {
  //     name: "1/2 Ton Regular Cab 4x4",
  //     daily: {
  //       rate: 66,
  //       mileage: 0.22,
  //       freeMiles: 100,
  //     },
  //     weekly: {
  //       rate: 385,
  //       mileage: 0.22,
  //       freeMiles: 1000,
  //     },
  //     monthly: {
  //       rate: 1200,
  //       mileage: 0.22,
  //       freeMiles: 2500,
  //     },
  //   },
  // ];

  // let flatBedTruck = [
  //   {
  //     name: "11ft F-550 Flatbed 2x4",
  //     daily: {
  //       rate: 85,
  //       mileage: 0.22,
  //       freeMiles: 50,
  //     },
  //     weekly: {
  //       rate: 495,
  //       mileage: 0.22,
  //       freeMiles: 500,
  //     },
  //     monthly: {
  //       rate: 1585,
  //       mileage: 0.18,
  //       freeMiles: 2000,
  //     },
  //   },
  //   {
  //     name: "9ft F-450 Flatbed Crew Cab 4x4",
  //     daily: {
  //       rate: 95,
  //       mileage: 0.22,
  //       freeMiles: 50,
  //     },
  //     weekly: {
  //       rate: 575,
  //       mileage: 0.22,
  //       freeMiles: 500,
  //     },
  //     monthly: {
  //       rate: 1650,
  //       mileage: 0.18,
  //       freeMiles: 2000,
  //     },
  //   },
  //   {
  //     name: "16ft F-550 Flatbed w/ Lift",
  //     daily: {
  //       rate: 98,
  //       mileage: 0.22,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 595,
  //       mileage: 0.22,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 1650,
  //       mileage: 0.18,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "22ft F-650 Flatbed w/ Lift",
  //     daily: {
  //       rate: 105,
  //       mileage: 0.22,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 650,
  //       mileage: 0.22,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 1795,
  //       mileage: 0.18,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "4-Yard F-550 Dump Truck",
  //     daily: {
  //       rate: 150,
  //       mileage: 0.22,
  //       freeMiles: 50,
  //     },
  //     weekly: {
  //       rate: 800,
  //       mileage: 0.22,
  //       freeMiles: 500,
  //     },
  //     monthly: {
  //       rate: 2350,
  //       mileage: 0.18,
  //       freeMiles: 2000,
  //     },
  //   },
  // ];

  // let trailers = [
  //   {
  //     name: "8.5ftx22ft Enclosed Trailer",
  //     daily: {
  //       rate: 85,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 595,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 1650,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "7ftx14ft Enclosed Trailer",
  //     daily: {
  //       rate: 60,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 395,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 950,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "5ftx8ft Enclosed Trailer",
  //     daily: {
  //       rate: 29,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 190,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 475,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "7ftx20ft Flatbed Trailer",
  //     daily: {
  //       rate: 57,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 360,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 800,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "8ftx24ft Deckover Trailer",
  //     daily: {
  //       rate: 80,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 500,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 1450,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "6ftx12ft Utility Trailer",
  //     daily: {
  //       rate: 32,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 245,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 495,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //   },
  //   {
  //     name: "8.5ftx28ft +5 Gooseneck Trailer",
  //     daily: {
  //       rate: 105,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     weekly: {
  //       rate: 725,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //     monthly: {
  //       rate: 1975,
  //       mileage: 0,
  //       freeMiles: 0,
  //     },
  //   },
  // ];


/* eslint-enable  */

  // Building out Personal Quote Functionality
  let distance;
  let mileageRate;
  let dayRate;
  let freeDayMiles;
  let weekRate;
  let freeWeekMiles;
  let monthRate;
  let freeMonthMiles;
  let totalRate;

  let getPersQuote = (
    pickupDate,
    pickupTime,
    dropoffDate,
    dropOffTime,
    mi,
    dayRate,
    weekRate,
    monthRate,
    freeDayMiles,
    freeWeekMiles,
    freeMonthMiles,
    quan,
    dis
  ) => {
    persGetQuote.style.display = "none";

    let momentPickupTime = moment(pickupTime, ['h:m a', 'H:m']);
    let momentdropOffTime = moment(dropOffTime, ['h:m a', 'H:m']);
    let moment1 = moment(pickupDate).set({
      hour: momentPickupTime.get('hour'),
      minute: momentPickupTime.get('minute'),
      second: 0,
      millisecond: 0,
    });
    let moment2 = moment(dropoffDate).set({
      hour: momentdropOffTime.get('hour'),
      minute: momentdropOffTime.get('minute'),
      second: 0,
      millisecond: 0,
    });
    let numDays = Math.abs(moment1.add(3, 'hours').diff(moment2, "days") - 1);
  

    let months = Math.floor(numDays / 30);
    let weeks = Math.floor((numDays - months * 30) / 7);
    let days = numDays - weeks * 7 - months * 30;

 

    let totalFreeMiles =
      (days * freeDayMiles) + (weeks * freeWeekMiles) + (months * freeMonthMiles);

    if (dis <= totalFreeMiles) {
      totalRate = (days * dayRate + weeks * weekRate + months * monthRate) * quan;
    
    } else {
      totalRate =
        (days * dayRate +
          weeks * weekRate +
          months * monthRate +
          (distance - totalFreeMiles) * mi) * quan;
      
    }

    totalRate = parseFloat(totalRate.toFixed(2));
    hiddenPersInput.value = totalRate.toFixed(2);
    let results = document.querySelector(".persResultsCost");
    results.innerHTML = "$" + totalRate.toFixed(2);
    persSubmit.style.display = "block";
  };



  let persGetQuote = document.querySelector(".getQuote");
  let hiddenPersInput = document.querySelector("#estimate");

  persGetQuote.addEventListener("click", function (e) {
    e.preventDefault();

    let results = document.querySelector(".persResultsCost");
    results.innerHTML =
      "<img style='width: 200px;' class='waiting' src='/wp-content/themes/city-rent-a-truck/dist/images/yellow.gif'>";

    let googPickup = document.querySelector("#persPickup").value;
    let googDropoff = document.querySelector("#persDropoff").value;
    let googDes = document.querySelector("#persDestination").value;

    if (googPickup === "KCI North Location") {
      googPickup = "10931 N Congress Ave, Kansas City, MO 64153";
    } else if (googPickup === "Plaza Location") {
      googPickup = "4620 Virginia Ave, Kansas City, MO 64110";
    } else if (googPickup === "Olathe Location") {
      googPickup = "15435 S. Hwy. 169, Olathe KS, 66062";
    }

    if (googDropoff === "KCI North Location") {
      googDropoff = "10931 N Congress Ave, Kansas City, MO 64153";
    } else if (googDropoff === "Plaza Location") {
      googDropoff = "4620 Virginia Ave, Kansas City, MO 64110";
    } else if (googDropoff === "Olathe Location") {
      googDropoff = "15435 S. Hwy. 169, Olathe KS, 66062";
    }

    initMap();





    function initMap() {
      const directionsService = new google.maps.DirectionsService();
      const directionsRenderer = new google.maps.DirectionsRenderer();
      

      
      directionsService.route(
        {
          origin: googPickup,
          destination: googDropoff,
          waypoints: [
            {
              location: googDes,
              stopover: false
            }],
          provideRouteAlternatives: false,
          travelMode: 'DRIVING',
          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'pessimistic'
          },
          unitSystem: google.maps.UnitSystem.IMPERIAL
        },    
        (response, status) => {
          if (status === "OK" && response) {
            directionsRenderer.setDirections(response);
            const route = response.routes[0];

            var distance = route.legs[0].distance.text;

            sessionStorage.setItem("distance", distance);
            
          } else {
            console.log("Directions request failed due to " + status);
          }
        });
    }

    

  let getDistance = (
    mi,
    dayRate,
    weekRate,
    monthRate,
    freeDayMiles,
    freeWeekMiles,
    freeMonthMiles,
    quan,
    pickup,
    dropoff,
    destination,
    pickupDate,
    pickupTime,
    dropoffDate,
    dropofftime
  ) => {
    if (pickup === "KCI North Location") {
      pickup = "10931 N Congress Ave, Kansas City, MO 64153";
    } else if (pickup === "Plaza Location") {
      pickup = "4620 Virginia Ave, Kansas City, MO 64110";
    } else if (pickup === "Olathe Location") {
      pickup = "15435 S. Hwy. 169, Olathe KS, 66062";
    }

    if (dropoff === "KCI North Location") {
      dropoff = "10931 N Congress Ave, Kansas City, MO 64153";
    } else if (dropoff === "Plaza Location") {
      dropoff = "4620 Virginia Ave, Kansas City, MO 64110";
    } else if (dropoff === "Olathe Location") {
      dropoff = "15435 S. Hwy. 169, Olathe KS, 66062";
    }

    let distance1 = 0;
    let distance2 = 0;





        setTimeout(() => {
          let distanceCalc = sessionStorage.getItem("distance");
        
      
          distance2 = distanceCalc.replace(/\D/g, "");
        

          distance = (distance1 + distance2);
          getPersQuote(
            pickupDate,
            pickupTime,
            dropoffDate,
            dropoffTime,
            mi,
            dayRate,
            weekRate,
            monthRate,
            freeDayMiles,
            freeWeekMiles,
            freeMonthMiles,
            quan,
            distance
          );
        }, 3000);
    
  };

  let getVeh = (
    arr,
    veh,
    pickup,
    dropoff,
    des,
    quan,
    pickupDate,
    pickupTime,
    dropoffDate,
    dropoffTime
  ) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].name === veh) {
        mileageRate = arr[i].daily.mileage;
        dayRate = arr[i].daily.rate;
        freeDayMiles = arr[i].daily.freeMiles;
        weekRate = arr[i].weekly.rate;
        freeWeekMiles = arr[i].weekly.freeMiles;
        monthRate = arr[i].monthly.rate;
        freeMonthMiles = arr[i].monthly.freeMiles;

        getDistance(
          mileageRate,
          dayRate,
          weekRate,
          monthRate,
          freeDayMiles,
          freeWeekMiles,
          freeMonthMiles,
          quan,
          pickup,
          dropoff,
          des,
          pickupDate,
          pickupTime,
          dropoffDate,
          dropoffTime
        );
      }
    }
  };

  let checkVehicle = (
    vehCat,
    vehType,
    pickup,
    dropoff,
    des,
    vehQuan,
    pickupDate,
    pickupTime,
    dropoffDate,
    dropoffTime
  ) => {
    switch (vehCat) {
      case "Passenger Vehicles":
        getVeh(
          passengerVan,
          vehType,
          pickup,
          dropoff,
          des,
          vehQuan,
          pickupDate,
          pickupTime,
          dropoffDate,
          dropoffTime
        );
        break;
      case "Cargo Vans":
        getVeh(
          cargoVan,
          vehType,
          pickup,
          dropoff,
          des,
          vehQuan,
          pickupDate,
          pickupTime,
          dropoffDate,
          dropoffTime
        );
        break;
      case "Pickup Trucks":
        getVeh(
          pickupTruck,
          vehType,
          pickup,
          dropoff,
          des,
          vehQuan,
          pickupDate,
          pickupTime,
          dropoffDate,
          dropoffTime
        );
        break;
      case "Box Trucks":
        getVeh(
          boxTruck,
          vehType,
          pickup,
          dropoff,
          des,
          vehQuan,
          pickupDate,
          pickupTime,
          dropoffDate,
          dropoffTime
        );
        break;
      case "Flatbed Trucks":
        getVeh(
          flatBedTruck,
          vehType,
          pickup,
          dropoff,
          des,
          vehQuan,
          pickupDate,
          pickupTime,
          dropoffDate,
          dropoffTime
        );
        break;
      case "Trailers":
        getVeh(
          trailers,
          vehType,
          pickup,
          dropoff,
          des,
          vehQuan,
          pickupDate,
          pickupTime,
          dropoffDate,
          dropoffTime
        );
    }
  };



  

    // Get form values and target form inputs for when we want to calculate rates
    let pickup = document.querySelector("#persPickup").value;
    let dropoff = document.querySelector("#persDropoff").value;
    let des = document.querySelector("#persDestination").value;
    let vehicleCat = document.querySelector("#persVehicleType").value;
    let perVeh = document.querySelector("#persVehiclePicked").value;
    let vehQuan = document.querySelector("#persVehQuantity").value;
    let pickUpDate = document.querySelector("#persPickupDate").value;
    let dropOffDate = document.querySelector("#persDropoffDate").value;
    let pickupTime = document.querySelector("#persPickupTime").value;
    let dropoffTime = document.querySelector("#persDropOffTime").value;

    let inputs = [
      pickup,
      dropoff,
      des,
      vehicleCat,
      perVeh,
      vehQuan,
      pickUpDate,
      dropOffDate,
    ];

    let validator = (input) => {
      return input != "" && input != "Vehicle Category";
    };

    if (inputs.every(validator)) {
      persGetQuote.style.display = "none";
      checkVehicle(
        vehicleCat,
        perVeh,
        pickup,
        dropoff,
        des,
        vehQuan,
        pickUpDate,
        pickupTime,
        dropOffDate,
        dropoffTime
      );
      let persResults = document.querySelector(".personalResults");
      persSubmit.style.display = "block";
      persResults.style.display = "block";
      persResults.classList.add("formSent");
    }
  });

  let afterPersSubmit = document.querySelector(".submitThankYou");
  let persForm = document.querySelector(".persForm");

  document.addEventListener(
    "wpcf7mailsent",
    function (form) {
      if ("615" == form.detail.contactFormId) {
        persSubmit.style.display = "none";
        persForm.style.display = "none";
        afterPersSubmit.classList.add("persSubmitted");
      } else if ("616" == form.detail.contactFormId) {
        let comResults = document.querySelector(".comThankYou");
        comResults.classList.add("formSent");
        comSubmit.style.display = "none";
      } else if ("617" == form.detail.contactFormId) {
        let resResults = document.querySelector(".thankYou");
        resResults.classList.add("formSent");
        resSubmit.style.display = "none";
      }
    },
    false
  );

  let modalActive = function (elem) {
    html.style.overflowY = "hidden";
    elem.classList.add("modalActive");
    elem.children[1].classList.add("modalContentActive");
  };

  let quoteModalClose = function (elem) {
    html.style.overflowY = "auto";
    elem.classList.remove("modalActive");
    elem.children[1].classList.remove("modalContentActive");
    document.getElementById("wpcf7-f615-o1").style.display = "none";
  };

  for (let i = 0; i < quickQuoteBtn.length; i++) {
    quickQuoteBtn[i].addEventListener("click", function () {
      modalActive(quoteModal);
    });
  }

  for (let i = 0; i < persQuoteBtn.length; i++) {
    persQuoteBtn[i].addEventListener("click", function () {
      modalActive(persModal);
      document.getElementById("wpcf7-f615-o1").style.display = "block";
    });
  }

  for (let i = 0; i < comQuoteBtn.length; i++) {
    comQuoteBtn[i].addEventListener("click", function () {
      modalActive(commModal);
    });
  }

  for (let i = 0; i < reservBtn.length; i++) {
    reservBtn[i].addEventListener("click", function () {
      modalActive(resModal);
    });
  }

  for (let i = 0; i < modalClose.length; i++) {
    modalClose[i].addEventListener("click", function () {
      let parent = modalClose[i].parentNode;
      quoteModalClose(parent);
    });
  }

  let perVeh = document.querySelector("#persVehiclePicked");

  // Updating Select options when vehicle category is chosen
  let updatePersVeh = (arr) => {
    perVeh.options.length = 0;

    for (let i = -1; i < arr.length; i++) {
      if (i === -1) {
        let option = document.createElement("option");
        option.text = "Select Model";
        option.disabled = true;
        option.selected = true;
        perVeh.add(option);
      } else {
        let option = document.createElement("option");
        option.text = arr[i].name;
        perVeh.add(option);
      }
    }
  };

  let vehCategory = document.querySelector("#persVehicleType");
  vehCategory.addEventListener("change", function () {
    let category = vehCategory.value;

    switch (category) {
      case "Passenger Vehicles":
        updatePersVeh(passengerVan);
        break;
      case "Cargo Vans":
        updatePersVeh(cargoVan);
        break;
      case "Pickup Trucks":
        updatePersVeh(pickupTruck);
        break;
      case "Box Trucks":
        updatePersVeh(boxTruck);
        break;
      case "Flatbed Trucks":
        updatePersVeh(flatBedTruck);
        break;
      case "Trailers":
        updatePersVeh(trailers);
        break;
    }
  });

  // Updating Select options when vehicle category is chosen
  let updateComVeh = (arr) => {
    let comVeh = document.getElementById("comVeh");
    comVeh.options.length = 0;

    for (let i = -1; i < arr.length; i++) {
      if (i == -1) {
        let option = document.createElement("option");
        option.text = "Select Model";
        option.disabled = true;
        option.selected = true;
        comVeh.add(option);
      } else {
        let option = document.createElement("option");
        option.text = arr[i].name;
        comVeh.add(option);
      }
    }
  };

  let comCategory = document.querySelector("#comVehCat");
  comCategory.addEventListener("change", function () {
    let category = comCategory.value;

    switch (category) {
      case "Passenger Vehicles":
        updateComVeh(passengerVan);
        break;
      case "Cargo Vans":
        updateComVeh(cargoVan);
        break;
      case "Pickup Trucks":
        updateComVeh(pickupTruck);
        break;
      case "Box Trucks":
        updateComVeh(boxTruck);
        break;
      case "Flatbed Trucks":
        updateComVeh(flatBedTruck);
        break;
      case "Trailers":
        updateComVeh(trailers);
        break;
    }
  });

  // Updating Select options when vehicle category is chosen
  let updateResVeh = (arr) => {
    let resVeh = document.getElementById("resVeh");
    resVeh.options.length = 0;

    for (let i = -1; i < arr.length; i++) {
      if (i === -1) {
        let option = document.createElement("option");
        option.text = "Select Model";
        option.disabled = true;
        option.selected = true;
        resVeh.add(option);
      } else {
        let option = document.createElement("option");
        option.text = arr[i].name;
        resVeh.add(option);
      }
    }
  };

  let resCat = document.querySelector("#resVehCat");
  resCat.addEventListener("change", function () {
    let category = resCat.value;

    switch (category) {
      case "Passenger Vehicles":
        updateResVeh(passengerVan);
        break;
      case "Cargo Vans":
        updateResVeh(cargoVan);
        break;
      case "Pickup Trucks":
        updateResVeh(pickupTruck);
        break;
      case "Box Trucks":
        updateResVeh(boxTruck);
        break;
      case "Flatbed Trucks":
        updateResVeh(flatBedTruck);
        break;
      case "Trailers":
        updateResVeh(trailers);
        break;
    }
  });
});

let pickupAllTimeOptions = '<option value="">Select a Time</option><option value="8:00am">8:00am</option><option value="8:15am">8:15am</option><option value="8:30am">8:30am</option><option value="8:45am">8:45am</option><option value="9:00am">9:00am</option><option value="9:15am">9:15am</option><option value="9:30am">9:30am</option><option value="9:45am">9:45am</option><option value="10:00am">10:00am</option><option value="10:15am">10:15am</option><option value="10:30am">10:30am</option><option value="10:45am">10:45am</option><option value="11:00am">11:00am</option><option value="11:15am">11:15am</option><option value="11:30am">11:30am</option><option value="11:45am">11:45am</option><option value="12:00pm">12:00pm</option><option value="12:15pm">12:15pm</option><option value="12:30pm">12:30pm</option><option value="12:45pm">12:45pm</option><option value="1:00pm">1:00pm</option><option value="1:15pm">1:15pm</option><option value="1:30pm">1:30pm</option><option value="1:45pm">1:45pm</option><option value="2:00pm">2:00pm</option><option value="2:15pm">2:15pm</option><option value="2:30pm">2:30pm</option><option value="2:45pm">2:45pm</option><option value="3:00pm">3:00pm</option><option value="3:15pm">3:15pm</option><option value="3:30pm">3:30pm</option><option value="3:45pm">3:45pm</option><option value="4:00pm">4:00pm</option><option value="4:15pm">4:15pm</option><option value="4:30pm">4:30pm</option><option value="4:45pm">4:45pm</option><option value="5:00pm">5:00pm</option>';
let pickupSaturdayOnly = '<option value="">Select a Time</option><option value="9:00am">9:00am</option><option value="9:15am">9:15am</option><option value="9:30am">9:30am</option><option value="9:45am">9:45am</option><option value="10:00am">10:00am</option><option value="10:15am">10:15am</option><option value="10:30am">10:30am</option><option value="10:45am">10:45am</option><option value="11:00am">11:00am</option><option value="11:15am">11:15am</option><option value="11:30am">11:30am</option><option value="11:45am">11:45am</option><option value="12:00pm">12:00pm</option>';

$('#persPickupDate').change(function() {
  let timeSelect = $('#persPickupTime');
  let selectedWeekDay = moment($('#persPickupDate').val()).weekday();

  timeSelect.empty();
  if(selectedWeekDay === 6) {
    timeSelect.append(pickupSaturdayOnly);
  } else if (selectedWeekDay === 0) {
    timeSelect.append('<option value="">Select a Time</option>');
  } else {
    timeSelect.append(pickupAllTimeOptions);
  }
});

$('#comPickupDate').change(function() {
  let timeSelect = $('#comPickupTime');
  let selectedWeekDay = moment($('#comPickupDate').val()).weekday();

  timeSelect.empty();
  if(selectedWeekDay === 6) {
    timeSelect.append(pickupSaturdayOnly);
  } else if (selectedWeekDay === 0) {
    timeSelect.append('<option value="">Select a Time</option>');
  } else {
    timeSelect.append(pickupAllTimeOptions);
  }
});


// WEBPACK FOOTER //
// ./scripts/CRAT.js